import { DialogService, GridAction } from '@eforall/dashboard';
import { EntrepreneurProspectApplication } from '@interfaces';
import { AccApplicationDialog } from '../../../../acc-application-dialog';

export function getActions(dialogService: DialogService) {

	const actions: GridAction<EntrepreneurProspectApplication>[] = [
		{
			iconClass: 'fa-regular fa-pencil',
			label: 'View',
			isEnabled: rows => !!rows.length,
			execute: async rows => {
				const accApplicationId = rows[0]?.accApplicationId;
				if (!accApplicationId) return;
				await dialogService.showCustom(AccApplicationDialog, { data: { accApplicationId } }, 900, 900);
			}
		},
	];

	return actions;
}